import * as React from 'react';
import { Box } from '@mui/material';
import { Export } from 'src/frontend-common/dto/Interfaces/IExport';
import { useGetAnalyticsExportsQuery, useGetExportsQuery } from 'src/redux/services/exports';
import { ExportsListWrapperProps } from 'src/frontend-common/dto/Interfaces/FrontendLookups';
import ExportListRemote from 'src/components/ExportListWrapper/ExportListRemote';

const ExportListWrapper: React.FC<ExportsListWrapperProps> = ({ productFilter }) => {
  const [exportItems, setExportItems] = React.useState<Export[] | null>(null);

  // the polling is needed to update the progress bar, yo
  const {
    data: exportsData,
    isLoading,
    isError,
  } = useGetExportsQuery(undefined, {
    pollingInterval: 5000,
    skip: productFilter === 'analytics',
  });

  const {
    data: exportsAnalyticsData,
    isLoading: isLoadingAnalyticsData,
    isError: isErrorAnalyticsData,
  } = useGetAnalyticsExportsQuery(undefined, {
    pollingInterval: 5000,
    skip: productFilter !== 'analytics',
  });

  React.useEffect(() => {
    if (exportsData) {
      if (productFilter !== 'analytics') {
        setExportItems(exportsData.items);
      }
    } else if (exportsAnalyticsData) {
      setExportItems(exportsAnalyticsData.documents);
    }
  }, [exportsData, productFilter, exportsAnalyticsData]);

  return (
    <Box>
      {(isError || isErrorAnalyticsData) && <ExportListRemote state="error" />}
      {isLoading || isLoadingAnalyticsData ? (
        <ExportListRemote state="loading" />
      ) : (
        !isError && !isErrorAnalyticsData && exportItems && <ExportListRemote state="ready" exports={exportItems} productFilter={productFilter} />
      )}
    </Box>
  );
};

export default ExportListWrapper;
